export default __webpack_public_path__ + "static/media/char-kway-teow.385e745a.png";